module.exports = __webpack_public_path__ + "static/banner-f24dc92b5c05543bb0b0e1a675107360.png";